export const buttonStyle = {
  borderRadius: '2rem',
  padding: '0.5rem',
  color: 'rgb(42, 51, 60)',
  width: '100%',
  textAlign: 'center',
};
